<template>
  <b-skeleton-wrapper :loading="loading">
    <template #loading>
      <b-skeleton type="input"></b-skeleton>
    </template>
    <slot></slot>
  </b-skeleton-wrapper>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class AdSkeletonInput extends Vue {
  @Prop({ default: true, type: Boolean, required: true }) loading;
}
</script>
